import * as am4core from '@amcharts/amcharts4/core';
import * as am4charts from '@amcharts/amcharts4/charts';
import am4themes_animated from '@amcharts/amcharts4/themes/animated';


export class Chart{
	constructor(dom_id, data, options){
		this.dom_id = dom_id;
		this.data = data;
		this.options = options;
		this.title = options.title;
		this.chart = this.newChart();
		this.events();		
	}
	
	newChart(){
		am4core.useTheme(am4themes_animated);
		
		let chart = am4core.create(this.dom_id, am4charts.XYChart);		
		chart.data = this.data;
		
		/*
		let gradient = new am4core.LinearGradient();
		gradient.addColor(am4core.color("green"));
		gradient.addColor(am4core.color("blue"));
		gradient.addColor(am4core.color("yellow"));
		gradient.addColor(am4core.color("red"));
		gradient.rotation = 270;
		
		chart.plotContainer.background.fill = gradient;
		chart.plotContainer.background.fillOpacity = 0.5;
		*/
		
		chart.plotContainer.background.fill = am4core.color(this.options.background_color);
		chart.plotContainer.background.fillOpacity = 0.1;
		
		let dateAxis = chart.xAxes.push(new am4charts.DateAxis());
		dateAxis.renderer.minGridDistance = 50;

		let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
		valueAxis.title.text = this.options.title;
		valueAxis.renderer.minGridDistance = 20;
		
		// create gradient background from options
		if('gradientColorSet' in this.options){
		
				let gradientSet = this.options.gradientColorSet;		
				for (let i = 1; i < gradientSet.length; i++) {
					
				// create gradient
						let gradient = new am4core.LinearGradient();
							gradient.addColor(am4core.color(gradientSet[i-1][0]));
							gradient.addColor(am4core.color(gradientSet[i][0]));
								gradient.rotation = 270;
						
						let range = valueAxis.axisRanges.create();
							range.value = gradientSet[i-1][1];
							range.endValue = gradientSet[i][1];
							range.axisFill.fill = gradient;
							range.axisFill.fillOpacity = 0.5;
							range.grid.strokeOpacity = 0;
						}
		}
		/*
		// create gradient
		let gradient = new am4core.LinearGradient();
			gradient.addColor(am4core.color("red"));
			gradient.addColor(am4core.color("blue"));
		gradient.rotation = 90;
		
		let gradient2 = new am4core.LinearGradient();
			gradient2.addColor(am4core.color("yellow"));
			gradient2.addColor(am4core.color("red"));
		gradient2.rotation = 90;
		
		// create range
		let range = valueAxis.axisRanges.create();
			range.value = 20;
			range.endValue = 22;
			range.axisFill.fill = gradient;
			range.axisFill.fillOpacity = 1;
			range.grid.strokeOpacity = 0;
				
		let range2 = valueAxis.axisRanges.create();
			range2.value = 22;
			range2.endValue = 24;
			range2.axisFill.fill = gradient2;
			range2.axisFill.fillOpacity = 1;
			range2.grid.strokeOpacity = 0;
		*/
		
		// Create series
		let series = chart.series.push(new am4charts.LineSeries());
		series.dataFields.valueY = "value";
		series.dataFields.dateX = "date";
		series.strokeWidth = 3;
		series.tooltip.getFillFromObject = false;
		series.tooltip.background.fill = am4core.color("#7F9DC3");
		series.connect = true;
		//series.tooltipHTML = "<p style='color:blue'>{value}</p><p style='color:red'>{value2}</p>";
		//series.tooltip.pointerOrientation = "vertical";
		
		// Set up tooltip
		  series.adapter.add("tooltipText", function(ev) {
			var text = "[bold]{dateX}[/]\n"
			chart.series.each(function(item) {
				if(item){
					text += "[" + item.stroke.hex + "]●[/]: {" + item.dataFields.valueY + "}\n";
				}
			});
			return text;
		  });
		
			let series2 = chart.series.push(new am4charts.LineSeries());
			series2.dataFields.valueY = "value2";
			series2.dataFields.dateX = "date";
			series2.stroke = am4core.color("red");
			series2.strokeWidth = 3;
			series2.connect = true;

				
		//series2.tooltip.pointerOrientation = "vertical";

		let bullet = series.bullets.push(new am4charts.CircleBullet());
		bullet.stroke = new am4core.InterfaceColorSet().getFor("background");
		bullet.strokeWidth = 2;
		bullet.tooltipText = "{valueY}";		
		bullet.circle.radius = 4;
		
		let bullet2 = series2.bullets.push(new am4charts.CircleBullet());
		bullet2.stroke = new am4core.InterfaceColorSet().getFor("background");
		bullet2.strokeWidth = 2;
		bullet2.tooltipText = "{valueY}";
		bullet2.circle.radius = 4;
		bullet2.circle.fill = am4core.color("red");

		chart.cursor = new am4charts.XYCursor();
		chart.cursor.snapToSeries = series;
		chart.cursor.xAxis = dateAxis;
		chart.cursor.yAxis = valueAxis;
		
		//chart.scrollbarY = new am4core.Scrollbar();
		//chart.scrollbarX = new am4core.Scrollbar();
		
		return chart;
	}
	
	exportPNG(){
		let chart = this.chart;
		
		// promise - wait for chart to end animation
		let myPromise = new Promise(function(myResolve, myReject) {
		
			chart.events.on('appeared', () => {					
				myResolve(chart);				
			});
		});
		
		return myPromise;
	}
		
	events(){
		let chart = this.chart;
		
		chart.events.on('datavalidated', () => {
		  $("#slider-wait-chart").hide();
		});
	}
	
	destroy(){
		this.chart.dispose();
	}
}